module.exports = __webpack_public_path__ + "static/logo-light-b023b87fe5d890824303069b44288a1b.svg";